import React, { useState } from "react";
import styled from "styled-components";
import fp from "lodash/fp";
import Spacer from "@components/common/Spacer";

const Wrapper = styled.div`
  ul {
    display: flex;
    justify-content: space-between;
    margin: 5px 0 0;
    .navigate {
      cursor: pointer;
      color: gray;
      padding: 3px;
    }
  }
  h3 {
    font-size: 1.4rem;
    font-weight: bold;
  }
  p {
    margin-top: 5px;
    color: #be320f;
  }
  table {
    width: 100%;
    th,
    td {
      text-align: center;
    }
  }
`;

const InnerWrapper = styled.div`
  border: 1px solid LightGray;
  border-radius: 5px;
  padding: 2px 5px;
`;

const DateItem = styled.td`
  width: 14%;
`;

const DateLabel = styled.span`
  color: ${p => (p.available ? "black" : "LightGray")};
  padding: 5px 2px;
  display: ${props => (props.date !== 0 ? "block" : "none")};
  border: ${p => (p.count > 0 ? "1px solid #be320f" : 0)};
  &:hover {
    cursor: ${p => (p.count > 0 ? "pointer" : "default")};
    background-color: ${p => (p.count > 0 ? "LightGray" : "white")};
  }
`;

const Status = styled.div`
  display: ${props => (props.date !== 0 ? "inline-block" : "none")};
  color: ${p => (p.count > 0 ? "#be320f" : "LightGray")};
  border: ${p => (p.count > 0 ? "1px solid LightGray" : 0)};
  padding: 5px 10px;
  &:hover {
    cursor: ${p => (p.count > 0 ? "pointer" : "default")};
    background-color: ${p => (p.count > 0 ? "LightGray" : "white")};
  }
`;

function getCalendarData(year, month) {
  const firstDay = new Date(year, month).getDay();
  const daysInMonth = 32 - new Date(year, month, 32).getDate();

  let figure = 1;
  const data = [];
  for (let i = 0; i < 6; i++) {
    const _days = [];
    for (let j = 0; j < 7; j++) {
      if (i === 0 && j < firstDay) {
        _days.push({ year: year, month: month, date: 0 });
      } else if (figure > daysInMonth) {
        if (j === 0) {
          break;
        } else {
          _days.push({ year: year, month: month, date: 0 });
        }
      } else {
        _days.push({ year: year, month: month, date: figure++ });
      }
    }
    if (_days.length > 0) {
      data.push(_days);
    }
  }
  return data;
}

function Month(year, month, onClick, start, status) {
  const data = getCalendarData(year, month);

  return data.map((week, idx1) => {
    const weekData = week.map((item, idx2) => {
      let available = true;
      if (start && item && item.date !== 0) {
        if (new Date(item.year, item.month, item.date) < start) {
          available = false;
        }
      }
      return (
        <DateItem key={idx2} onClick={onClick} available={available}>
          <DateLabel
            date={item.date}
            available={available}
            count={status[getDateStr(item)]?.length || 0}
            data-date={getDateStr(item)}
          >
            {item.date}
          </DateLabel>
          {/*<Status*/}
          {/*  date={item.date}*/}
          {/*  available={available}*/}
          {/*  count={status[getDateStr(item)]?.length || 0}*/}
          {/*  onClick={onClick}*/}
          {/*  data-date={getDateStr(item)}*/}
          {/*>*/}
          {/*  {status[getDateStr(item)]?.length || 0}*/}
          {/*</Status>*/}
        </DateItem>
      );
    });
    return <tr key={idx1}>{weekData}</tr>;
  });
}

function changeMonth(current, value) {
  const { year, month } = current;
  if (value < 0) {
    const _year = month === 0 ? year - 1 : year;
    const _month = month === 0 ? 11 : month + value;
    return { year: _year, month: _month };
  } else {
    const _year = month === 11 ? year + 1 : year;
    const _month = month === 11 ? 0 : month + value;
    return { year: _year, month: _month };
  }
}

function getDateStr(date) {
  const yyyy = date.year;
  const mm = date.month < 9 ? "0" + (date.month + 1) : date.month + 1;
  const dd = date.date < 10 ? "0" + date.date : date.date;

  return `${yyyy}-${mm}-${dd}`;
}

function Calendar({ data, year, month, header, onClick, start }) {
  const [current, setCurrent] = useState({ year: year, month: month });
  const obj = fp.groupBy("date", data);

  return (
    <Wrapper>
      <h3>{header}</h3>
      <Spacer axis={"vertical"} size={10}></Spacer>
      {/*<p>신청 가능일(빨간색)을 눌러서 신청해주세요</p>*/}
      {/*<Spacer axis={"vertical"} size={10}></Spacer>*/}
      <InnerWrapper>
        <ul>
          <li
            onClick={() => {
              const prev = changeMonth(current, -1);
              setCurrent({ year: prev.year, month: prev.month });
            }}
            className={"navigate"}
          >
            &#60; 이전 달
          </li>
          <li>
            <span>
              {current.year}년 {current.month + 1}월
            </span>
          </li>
          <li
            onClick={() => {
              const next = changeMonth(current, 1);
              setCurrent({ year: next.year, month: next.month });
            }}
            className={"navigate"}
          >
            다음 달 &#62;
          </li>
        </ul>
        <hr />
        <table>
          <thead>
            <tr>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
          </thead>
          <tbody>
            {Month(current.year, current.month, onClick, start, obj)}
          </tbody>
        </table>
      </InnerWrapper>
      <p>* 둘러보기 신청 가능일</p>
    </Wrapper>
  );
}

export default Calendar;
